


















import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';

import { store } from '../store/edit';

export default PageModeMixin.extend({
	name: 'StavPoVraceni',
	props: {
		storeUri: String,
		zapujckaStav: Object,
	},
	computed: {
		...genVuexComputeds(store),
		isPujckaDatDoRequired(): boolean {
			return this.zapujckaStav.isPujcena;
		},
		isKmStavDoRequired(): boolean {
			return !!this.VozidlopaId && !this.OstatnipaId;
		},
		isStavPoDisabled(): boolean {
			return this.zapujckaStav.isVracena || this.zapujckaStav.isKFakturaci || this.zapujckaStav.isFakturovana
				|| this.RozsirProtokol || this.isViewMode;
		},
	},
});
